module.exports = __webpack_public_path__ + "077d3c5485f00b75591ee1b9bdc3d2e9.jpg";